import ScrollMagic from 'scrollmagic';
import device from '../util/device';

export default {

    init() {

        var scrollRevealHandler = function() {
            var $el = $(this);

            if ($el.hasClass('is-revealed')) {
                return;
            }

            $el.addClass('is-revealed');

            // Autoplay videos on scroll
            if ($el.is('.js-autoplay')) {
                // Autoplay videos on none small devices
                if (!device.isSmlDevice(768)) {
                    var video = $el.get(0);
                    video.play();
                }
            }

        }

        $('body').on('reveal', '.js-scrollreveal', scrollRevealHandler);

        var initScrollAnimations = function() {
            // Controller
            var controller = new ScrollMagic.Controller({});

            // Reveal elements
            $('.js-scrollreveal').each(function() {
                var element = $(this);
                var scene = new ScrollMagic.Scene({
                    triggerHook: 0.95,
                    offset: 100,
                    triggerElement: element.get(0),
                    reverse: false,
                });

                scene.on('start', function(e) {
                    if (e.scrollDirection != 'REVERSE' && !$('html').hasClass('prehome-active')) {
                        element.trigger('reveal');
                        scene.remove();
                    }
                });
                scene.addTo(controller);
            });

        }

        initScrollAnimations();


    },
}


// WEBPACK FOOTER //
// ./scripts/components/animations.js